export default __webpack_public_path__ + "static/media/forestly-expl-nn-01_EN.5dc266bc.png";